export const download = (resource, fileName) => {
  return fetch(resource, {
    method: "GET",
    mode: "cors",
    headers: {
      Authorization: `Session ${localStorage.getItem("auth")}`,
    },
    responseType: "blob",
  })
    .then(response => {
      if (response.ok) {
        return {
          name: fileName || response.headers.get("X-File-Name"),
          blob: response.blob(),
        };
      }
      // if (response.status === 401) {
      //   refreshToken(settings);
      // }
      throw Error(`Request rejected with status ${response.status}`);
    })
    .then(data => {
      return Promise.resolve(data);
    })
    .then(data => {
      data.blob.then(blob => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, data.name);
        } else {
          const link = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = link;
          a.download = data.name;
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove(); // afterwards we remove the element again
        }
      });
    });
};
